import { render, staticRenderFns } from "./AccountDisabled.vue?vue&type=template&id=425663e0"
import script from "./AccountDisabled.vue?vue&type=script&lang=ts"
export * from "./AccountDisabled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports